/* eslint-disable @typescript-eslint/no-unused-vars */

import { CircularProgress, IconButton, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import MinusIcon from '@material-ui/icons/Remove'
import React from 'react'

import useStyles from './styles/index.styles'

type Props = {
  value: number
  setValue: (val: number) => void
  disable: boolean
  max?: number
  smallSize?: boolean
  loading?: boolean
}

const CustomCounter = ({
  value,
  setValue,
  disable,
  max,
  smallSize,
  loading
}: Props) => {
  const classes = useStyles()
  const increase = () => {
    if (max) {
      if (value < max) {
        setValue(value + 1)
      }
    } else {
      setValue(value + 1)
    }
  }

  const decrease = () => {
    if (value != 0) {
      setValue(value - 1)
    }
  }
  return (
    <div className={[classes.root, smallSize && classes.rootSmall].join(' ')}>
      <IconButton
        onClick={() => {
          decrease()
        }}
        className={[classes.button, smallSize && classes.buttonSmall].join(' ')}
        size="small"
        disabled={disable}>
        <MinusIcon />
      </IconButton>
      <Typography
        className={[
          classes.countValue,
          smallSize && classes.countValueSmall
        ].join('')}
        color="primary">
        {loading ? (
          <CircularProgress className={classes.circularProgress} size={12} />
        ) : (
          value
        )}
      </Typography>
      <IconButton
        onClick={() => {
          increase()
        }}
        className={[classes.button, smallSize && classes.buttonSmall].join(' ')}
        size="small"
        disabled={disable}>
        <AddIcon />
      </IconButton>
    </div>
  )
}

export default CustomCounter
